import React from "react";
import { Summary } from "@virkesborsen/ui-component-library";
import { formatPriceWithCurrency } from "../../../utils";

const getDiscountPrice = (price) => {
  return price ? `- ${formatPriceWithCurrency(price)}` : undefined;
};

const OrderSummary = ({ checkoutData }) => {
  const summaryItems = [
    // {
    //   label: `Skogsövervakning - 1 år`,
    //   value: formatPriceWithCurrency(checkoutData?.basePrice),
    // },
    // {
    //  label: `Rabatt - ${checkoutData?.propertyDiscountPercentage}% (baserat på din fastighet)`,
    //   value: getDiscountPrice(checkoutData.propertyDiscountPrice),
    // },
    {
      label: "Rabattkod",
      value: getDiscountPrice(checkoutData.couponDiscountPrice),
    },
    // {
    //   label: "Moms",
    //   value: formatPriceWithCurrency(checkoutData?.tax),
    // },
    {
      label: "Startdatum",
      value: "Idag",
    },
  ].filter((item) => item.value);

  return (
    <Summary
      title="Sammanfattning"
      color="white-50"
      items={summaryItems}
      total={{
        label: "Total",
        value: formatPriceWithCurrency(checkoutData?.netPrice),
        subValue: "Exklusive moms",
      }}
    />
  );
};

export default OrderSummary;
